import React, { useState } from 'react';
import SearchModal from './SearchModal';
import searchAvatar from '@/assets/search-avatar.png';

export default function FloatingSearchButton() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      {/* Floating Avatar Button */}
      <button
        onClick={() => setIsModalOpen(true)}
        className="fixed bottom-6 right-6 z-40 group no-print"
        aria-label="Open search"
      >
        {/* Pulse animation ring */}
        <span className="absolute inset-0 rounded-full bg-primary/30 animate-ping" />
        
        {/* Avatar container */}
        <div className="relative w-14 h-14 rounded-full overflow-hidden border-2 border-primary shadow-lg shadow-primary/25 transition-all duration-300 group-hover:scale-110 group-hover:shadow-xl group-hover:shadow-primary/40">
          <img
            src={searchAvatar}
            alt="Search"
            className="w-full h-full object-cover"
          />
        </div>

        {/* Tooltip */}
        <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 px-3 py-1.5 bg-card border border-border rounded-lg text-sm font-medium text-foreground whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity shadow-lg pointer-events-none">
          Search docs
        </span>
      </button>

      {/* Search Modal */}
      <SearchModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
      />
    </>
  );
}
